import { useEffect, useState } from "react";
import {
  applyActionCode,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from "firebase/auth";
import { auth } from "@/firebase";

const rutappLogo = "/images/rutapp-logo.png.png";

export function FirebaseActionHandler() {
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const oobCode = params.get("oobCode");
  const apiKey = params.get("apiKey");
  const continueUrl = params.get("continueUrl");
  const lang = params.get("lang");

  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const prepareAction = async () => {
      if (!mode || !oobCode) {
        setStatus("error");
        setMessage("El enlace no es válido o está incompleto.");
        return;
      }

      try {
        if (mode === "verifyEmail") {
          await applyActionCode(auth, oobCode);
          setStatus("success");
          setMessage("Tu correo electrónico ha sido verificado correctamente.");
          return;
        }

        if (mode === "resetPassword") {
          const accountEmail = await verifyPasswordResetCode(auth, oobCode);
          setEmail(accountEmail);
          setStatus("reset");
          return;
        }

        setStatus("error");
        setMessage("Este tipo de enlace no está disponible.");
      } catch (error) {
        console.error("[FIREBASE_ACTION]", error);
        setStatus("error");
        setMessage("El enlace ha caducado, ya fue utilizado o no es válido.");
      }
    };

    prepareAction();
  }, [mode, oobCode]);

  const handleResetPassword = async (event) => {
    event.preventDefault();

    if (password.length < 6) {
      setMessage("La contraseña debe tener al menos 6 caracteres.");
      return;
    }

    try {
      setIsSubmitting(true);
      setMessage("");

      await confirmPasswordReset(auth, oobCode, password);

      setStatus("success");
      setMessage("Tu contraseña se ha cambiado correctamente.");
    } catch (error) {
      console.error("[FIREBASE_PASSWORD_RESET]", error);
      setMessage("No se pudo cambiar la contraseña. Solicita un nuevo enlace.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center space-y-6">
        <img
          src={rutappLogo}
          alt="Rutapp"
          className="h-24 w-auto mx-auto"
        />

        {status === "loading" && (
          <p className="text-white">Comprobando enlace…</p>
        )}

        {status === "reset" && (
          <form onSubmit={handleResetPassword} className="space-y-4">
            <h1 className="text-xl font-semibold text-white">
              Nueva contraseña
            </h1>

            <p className="text-sm text-gray-300">{email}</p>

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nueva contraseña"
              minLength={6}
              required
              className="w-full rounded-md px-3 py-2 text-black bg-white"
            />

            {message && (
              <p className="text-sm text-red-400">{message}</p>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full rounded-md bg-yellow-400 px-4 py-2 font-semibold text-black disabled:opacity-60"
            >
              {isSubmitting ? "Guardando…" : "Cambiar contraseña"}
            </button>
          </form>
        )}

        {(status === "success" || status === "error") && (
          <>
            <p
              className={
                status === "success"
                  ? "text-green-400"
                  : "text-red-400"
              }
            >
              {message}
            </p>

            <a
              href="/"
              className="inline-block rounded-md bg-yellow-400 px-5 py-2 font-semibold text-black"
            >
              Ir a Rutapp
            </a>
          </>
        )}
      </div>
    </div>
  );
}
